import Cookie from 'js-cookie';
import moment from '~/notify/settings/__modules__/utils/moment';

export const language = Cookie.get('language') || 'en_US';
export const timezone = Cookie.get('timezone') || '';

class EnvService {
  static getOffset = function () {
    return moment().getOffset(timezone);
  };

  static getLocalTimeZoneOffset = function () {
    return moment().getLocalTimeZoneOffset();
  };

  static getTimeZoneOffset = function () {
    return EnvService.getOffset();
  };

  static getTimeZoneTime = function (srcTime) {
    const time = moment().getTimeZoneTime(srcTime, timezone);
    return time;
  };

  static getGMTOffsetObj() {
    return moment().getGMTOffsetObj(timezone);
  }
}

export default EnvService;
